export default "__VITE_PUBLIC_ASSET__b6f67f69__"